module.exports = __webpack_public_path__ + "static/media/shelter.9a900506.svg";